import {
    AreaField,
    InputField,
    ToastContext
} from '@enter/core';

import {RootStore} from 'stores';
import {Formik, FormikHelpers as FormikActions, FormikProps} from 'formik';
import React, {useContext} from 'react';
import * as Yup from 'yup';
import * as S from './notes-dialog.styles';
import {inject, observer} from "mobx-react";
import {DialogContext} from "services";
import _ from "lodash";

type FormProps = {
    notes: string;
}

const initialValues: FormProps = {
    notes: ''
};

type NotesDialogProps = {
    notes?: string;
    readOnly?: boolean;
    onClose: () => void;
    onSubmit: (notes: string) => Promise<string|undefined>;
};

const schema = Yup.object().shape({
    notes: Yup.string()
});

export const NotesDialog: React.FunctionComponent<NotesDialogProps> = inject('rootStore')(
    observer(
        (props: NotesDialogProps): React.ReactElement => {
            const dialogContext = useContext(DialogContext);
            const toastContext = useContext(ToastContext);

            const initValues = props.notes ? {notes: props.notes} : initialValues;

            const rootStore: RootStore = _.get(props, 'rootStore');
            if (!rootStore) {
                return <></>;
            }

            const { claimStore } = rootStore;
            const { onClose, onSubmit } = props;

            const handleCancel = (): void => {
                onClose?.();
            };

            const handleSubmit = async (
                formProps: FormProps,
                { setSubmitting }: FormikActions<any>,
            ): Promise<void> => {
                setSubmitting(true);

                let retToastMessage: string|undefined = undefined;

                try {
                    retToastMessage = await onSubmit(formProps.notes);
                } catch (err) {
                    dialogContext.showError(err);
                } finally {
                    setSubmitting(false);
                }

                if(retToastMessage) {
                    toastContext.notify?.(retToastMessage, 'right');
                }

            };

            return (
                <S.DialogBody>
                    <Formik initialValues={initValues} validationSchema={schema} onSubmit={handleSubmit}>
                        {(formik: FormikProps<FormProps>): React.ReactElement => (
                            <>
                                <S.InputRow>
                                    <S.InputAmount>
                                        <S.Label>Notes</S.Label>
                                        {props.readOnly ? <S.Label>{props.notes}</S.Label> : <S.FormField name="notes" component={AreaField} />}
                                    </S.InputAmount>
                                </S.InputRow>
                                <S.ButtonGroup
                                    changed={true}
                                    useNotify={false}
                                    onCancel={handleCancel}
                                    onSave={formik.submitForm}
                                    saveLabel={props.readOnly ? 'Ok' : 'Save'}
                                />
                            </>
                        )}
                    </Formik>
                </S.DialogBody>
            );
        },
    ),
);
